function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "validate_svg__a",
  x1: "66.003%",
  x2: "34.791%",
  y1: "3.622%",
  y2: "94.701%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E4E8F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#C9CDD9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "validate_svg__b",
  x1: "75.365%",
  x2: "29.95%",
  y1: "36.03%",
  y2: "57.679%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#E4E8F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "validate_svg__c",
  x1: "75.31%",
  x2: "25.946%",
  y1: "3.622%",
  y2: "94.701%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E4E8F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#C9CDD9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "validate_svg__d",
  x1: "0%",
  y1: "55.339%",
  y2: "55.339%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00907F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#48D59F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "validate_svg__e",
  x1: "0%",
  y1: "55.339%",
  y2: "55.339%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00907F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#48D59F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "validate_svg__f",
  x1: "75.31%",
  x2: "25.946%",
  y1: "49.617%",
  y2: "50.369%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E4E8F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#C9CDD9"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#validate_svg__a)",
  d: "M2.058 9.907a1.896 1.896 0 00-1.891 1.9V78.1c0 1.05.847 1.9 1.891 1.9H54.01c1.045 0 1.892-.85 1.892-1.9V11.808c0-1.049-.847-1.9-1.892-1.9H2.058z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M5.95 72.289h43.374V16.386H5.95z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#validate_svg__b)",
  d: "M23.151.208c-1.873 0-3.392 1.546-3.392 3.454v1.633h-1.806c-1.733 0-3.138 1.43-3.138 3.196v3.849h26.437V8.49c0-1.765-1.405-3.196-3.138-3.196h-1.806V3.662c0-1.908-1.518-3.454-3.391-3.454H23.15z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#validate_svg__c)",
  d: "M11.733 53.747h6.747V47h-6.747zm0-23h6.747V24h-6.747zm0 11h6.747V35h-6.747zm0 23h6.747V58h-6.747z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#validate_svg__d)",
  d: "M15.271 27.484l-1.513-1.654-.944 1.032 2.457 2.688 4.772-5.221-.944-1.032z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#validate_svg__e)",
  d: "M15.271 39.183l-1.513-1.655-.944 1.033 2.457 2.687 4.772-5.22-.944-1.033z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#validate_svg__f)",
  d: "M22.336 50.928H43.54V49H22.336zm0 11H43.54V60H22.336zm0-33H43.54V27H22.336zm0 11H43.54V38H22.336z"
}));

function SvgValidate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 80"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,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";
export { SvgValidate as ReactComponent };